import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { NavLink as RouterLink } from 'react-router-dom';
import withAnalytics from '../../hocs/withAnalytics';
import AuthLink from './AuthLink';
import styles from './Link.module.css';

const Link = ({
  to,
  auth,
  external,
  children,
  className,
  intents,
  ...props
}) => {
  const commonProps = {
    className: classnames(
      styles.component,
      intents?.map((intent) => styles[`component-${intent}`]),
      className
    ),
  };

  if (external) {
    return (
      <a href={to} {...props} {...commonProps}>
        {children}
      </a>
    );
  }

  return auth ? (
    <AuthLink to={to} {...props} {...commonProps}>
      {children}
    </AuthLink>
  ) : (
    <RouterLink to={to} {...props} {...commonProps}>
      {children}
    </RouterLink>
  );
};

Link.propTypes = {
  auth: PropTypes.bool,
  external: PropTypes.bool,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func])
    .isRequired,
};

Link.defaultProps = {
  auth: false,
  external: false,
  to: '/',
};

export default Link;

export const LinkWithAnalytics = withAnalytics(Link);
